namespace TabAurous.Sales {
    export namespace SalesPostingService {
        export const baseUrl = 'Sales/SalesPosting';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<Common.MasterTransaction>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Sales/SalesPosting/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>SalesPostingService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
